var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user)?[(_vm.websocket.status)?_c('span',{staticStyle:{"color":"green"}},[_vm._v(" | "),_c('i',{staticClass:"fa fa-heart"})]):_c('span',{staticStyle:{"color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.refresh_page()}}},[_vm._v(" | "),_c('i',{staticClass:"fa fa-heart"})])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }